import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions'
import * as mutations from './mutations'
import * as getters from './getters'
import modules from './modules';

Vue.use(Vuex)
const store = new Vuex.Store({
    modules: modules,
    getters,
    actions,
    mutations
})
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js